import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import {BASE_CLASS} from './config.js'
import YoutubeIframe from './media-video-youtube-iframe.js'
import YoutubePlaceholder from './media-video-youtube-placeholder.js'

export default function MediaVideo({
  isPlayable = true,
  onClickPlaceholder,
  placeholderImageSrc,
  preventIframeLoad,
  showPlaceholderOnMobile = false,
  title,
  videoId,
  videoURL
}) {
  const {domain} = useContext(Context)

  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const shouldRenderPlaceholder =
    !isPlayable || (preventIframeLoad && !isMobile) || (preventIframeLoad && isMobile && showPlaceholderOnMobile)

  return (
    <div className={BASE_CLASS}>
      {shouldRenderPlaceholder ? (
        <YoutubePlaceholder
          isPlayable={isPlayable}
          onClickPlaceholder={onClickPlaceholder}
          placeholderImageSrc={placeholderImageSrc}
          videoId={videoId}
          videoURL={videoURL}
          title={title}
        />
      ) : (
        <YoutubeIframe videoURL={videoURL} title={title} />
      )}
    </div>
  )
}

MediaVideo.displayName = 'MediaVideo'
MediaVideo.propTypes = {
  isPlayable: PropTypes.bool,
  onClickPlaceholder: PropTypes.func,
  placeholderImageSrc: PropTypes.string,
  preventIframeLoad: PropTypes.bool,
  showPlaceholderOnMobile: PropTypes.bool,
  title: PropTypes.string,
  videoId: PropTypes.string,
  videoURL: PropTypes.string
}
